import { get, set } from "dot-prop-immutable";
//import { throttle } from "lodash";

import { RTC_ACTION } from "../model/Rtc";

import { DATALOG_SET_XRANGE, genLogValues, genStateChanges } from "./Datenlog";

export const CHARTS_DATA_SOURCE_LIVE_STANDARD = 0;
export const CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES = 1;

export const chartsDataSourceIndex = [
	{ i18n_key: "Live (Standard)", value: CHARTS_DATA_SOURCE_LIVE_STANDARD },
	{ i18n_key: "Sd-Card Log-Files", value: CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES }
];

const CHARTS_REBUILD_LOG_VALUES = "CHARTS_REBUILD_LOG_VALUES";
const CHARTS_SET_YCOMPONENT = "CHARTS_SET_YCOMPONENT";
const CHARTS_SET_YVALUE = "CHARTS_SET_YVALUE";
export const CHARTS_SET_XRANGE = "CHARTS_SET_XRANGE";
const CHARTS_SET_XMODE = "CHARTS_SET_XMODE";
const CHARTS_SET_YRANGE = "CHARTS_SET_YRANGE";
const CHARTS_SET_YMODE = "CHARTS_SET_YMODE";
const CHARTS_SHOW_COMPRESSOR_STATE = "CHARTS_SET_COMPRESSOR_STATE";
const CHARTS_SET_DAILY_REQUEST_PENDING = "CHARTS_SET_DAILY_REQUEST_PENDING";
const CHARTS_SET_DAILY_TIMESPAN = "CHARTS_SET_DAILY_TIMESPAN";
const CHARTS_SET_DAILY_VALUES = "CHARTS_SET_DAILY_VALUES";
const CHARTS_SET_LOG_VALUES = "CHARTS_SET_LOG_VALUES"
const CHARTS_SET_STATE_CHANGES = "CHARTS_SET_STATE_CHANGES"
export const CHARTS_SET_DATA_SOURCE = "CHARTS_SET_DATA_SOURCE";

export const X_MODE_X_AUTO = "X-Auto";
export const X_MODE_MANUAL = "Manual";
export const X_MODE_10MIN = "10 min";
export const X_MODE_30MIN = "30 min";
export const X_MODE_1H = "1 h";
export const X_MODE_MAX = "Max";

export const X_MODES = [
	X_MODE_X_AUTO,
	X_MODE_MANUAL,
	X_MODE_10MIN,
	X_MODE_30MIN,
	X_MODE_1H,
	X_MODE_MAX
];

export const Y_MODE_AUTO = "auto";
export const Y_MODE_MANUAL = "manual";

const rebuildLogValuesAction = () => ({
	type: CHARTS_REBUILD_LOG_VALUES
});

export const setYComponentAction = index => ({
	type: CHARTS_SET_YCOMPONENT,
	index
});

export const setYValueAction = index => ({
	type: CHARTS_SET_YVALUE,
	index
});

/* is_x_auto_update sollte nur durch die Middleware verwendet werden */
export const setXRangeAction = (range, is_manual_change = true) => ({
	type: CHARTS_SET_XRANGE,
	/* [min, max], beide Werte kompatibel zu log_values[x].date */
	range,
	is_manual_change
});

export const setXModeAction = mode => ({
	type: CHARTS_SET_XMODE,
	mode
});

export const setYRangeAction = range => ({
	type: CHARTS_SET_YRANGE,
	/* [min, max], beide Werte kompatibel zum aktuellen y_value */
	range
});

export const setYModeAction = mode => ({
	type: CHARTS_SET_YMODE,
	mode
});

export const setShowCompressorStateAction = value => ({
	type: CHARTS_SHOW_COMPRESSOR_STATE,
	value
});

export const setDailyTimespanAction = (from_ms, until_ms) => ({
	type: CHARTS_SET_DAILY_TIMESPAN,
	from_ms, until_ms
});

export const setDailyRequestPending = (which, value) => ({
	type: CHARTS_SET_DAILY_REQUEST_PENDING,
	which, value
});

export const setDailyValuesAction = (which, data, from_ms, until_ms, now_ms) => ({
	type: CHARTS_SET_DAILY_VALUES,
	which, data, from_ms, until_ms, now_ms
});

export const setChartsLogValuesAction = (logValues) => ({
	type: CHARTS_SET_LOG_VALUES,
	log_values: logValues
})

export const setChartsStateChangesAction = (stateChanges) => ({
	type: CHARTS_SET_STATE_CHANGES,
	stateChanges: stateChanges
})

export const chartsSetDataSourceAction = (dataSourceIndex) => ({
	type: CHARTS_SET_DATA_SOURCE,
	data_source_index: dataSourceIndex
})

const makeYValue = (index, path, i18n_key, unit, y_min, y_step, standard_range) => ({
	index,
	path,			/* Zugriff auf Wert in log_values[x] */
	i18n_key,
	unit,			/* Für Anzeige Wert im Tooltip */
	y_min,			/* Begrenzung Verschiebung Y-Achse */
	y_step,			/* Minimaler Abstand in domain */
	standard_range	/* der uebliche Startwert fuer die y-Achse */
});

const makeYValues = y_component_index => {
	return y_component_index === -1
		? [
			makeYValue(0, "ablauf.master.system_pressure_bar", "System pressure", "pressure", 0, 0.1, [0, 10]),
			makeYValue(1, "ablauf.master.delivery_volume_m3min", "Delivery volume", "volume_over_minutes", 0, 1, [0, 1]),
			makeYValue(2, "ablauf.master.energy_consumption_kW", "Power", "power", 0, 1, [0, 10]),
			makeYValue(3, "ablauf.master.volume_flow_m3min", "Volume flow", "volume_over_minutes", 0, 1, [0,1]),
			makeYValue(4, "ablauf.master.load_factor_percent", "Load factor", "percent", 0, 1, [0, 1])
		]
		: [
			makeYValue(0, `ablauf.compressors.${y_component_index}.line_pressure_bar`, "System pressure", "pressure", 0, 0.1, [0, 10]),
			makeYValue(1, `ablauf.compressors.${y_component_index}.delivery_volume_m3min`, "Delivery volume", "volume_over_minutes", 0, 1, [0,1]),
			makeYValue(2, `ablauf.compressors.${y_component_index}.electrical_power_kW`, "Power", "power", 0, 1, [0, 10]),
			makeYValue(3, `ablauf.compressors.${y_component_index}.temperature_degC`, "Temperature", "temperature", -273.15, 1, [0, 100])
		];
};

const makeDaily = () => ({
	last_request_ms: null,
	from_ms: null,
	until_ms: null,
	data: []
});

const makeInitialState = () => {
	const y_component_index = -1;
	const y_values = makeYValues(y_component_index);
	return {
		y_component_index: y_component_index,
		y_values: y_values,
		y_value: y_values[1],
		x_mode: X_MODE_X_AUTO,
		x_range: ["dataMin", "dataMax"],	/* wird sowieso in der Middleware angepasst */
		y_mode: Y_MODE_AUTO,
		y_range: null,	/* wird in Grafiken "notfalls" selbst ermittelt, falls noch kein Bereich gewählt wurde */
		show_compressor_state: false, /* TODO: sollte true sein, aber weil die Statusanzeige noch nicht OK ist ... */
		log_values: [],
		state_changes: {
			num_compressors: null,
			changes: []
		},
		daily_values: {
			/* Für die Anzeige auf der rechten Seite, ist stets gleich für alle
			 * Diagramme/Tabellen. Jede konkrete Statistik merkt sich selber,
			 * welche Abfrage denn die letzte war, und die React Komponenten
			 * bestimmen dann, wann und ob eine neue Abfrage fällig wird.
			 * 
			 * Die middleware hier ist dafür zuständig, timespan
			 * - bei Start der Anwendung mit einem sinnvollen Startwert zu versorgen
			 * - bei Tageswechsel die aktuellen Werte entsprechend weiter zu schieben
			 */
			timespan: {
				from_ms: null,
				until_ms: null
			},
			last_leerlauf: makeDaily(),
			motorstarts: makeDaily(),
			spezifische_leistungsaufnahme: makeDaily(),
			energieverbrauch: makeDaily()
		},
		data_source_index: CHARTS_DATA_SOURCE_LIVE_STANDARD
	};
};

const initial_state = makeInitialState();

export const chartsReducer = (state = initial_state, action) => {
	switch (action.type) {
	case CHARTS_REBUILD_LOG_VALUES: {
		const log_values = genLogValues(state.x_range);
		let new_state = set(state, "log_values", log_values);
		if (state.show_compressor_state) {
			new_state.state_changes = genStateChanges(state.x_range);
		}
		return new_state;
	}
	case CHARTS_SET_YCOMPONENT: {
		let new_state = set(state, "y_component_index", action.index);
		/*
		if ((new_state.y_component_index < 0 && state.y_component_index >= 0) ||
			(new_state.y_component_index >= 0 && state.y_component_index < 0)) {
		*/
			/* Menüauswahl für die Diagramme hat sich geändert: neue Y-Werte */
			new_state.y_values = makeYValues(new_state.y_component_index);
			/* Mal sehen, ob sich ein "kompatibler" Eintrag für y_value zur bestehenden
			 * Auswahl finden lässt. Ansonsten einen Standardwert nehmen und Auto-Y
			 * auslösen.
			 */
			new_state.y_value = null;
			new_state.y_values.forEach(y_value => {
				/* "Kompatibel" heisst: gleiche Einheit (z.B. "bar") und gleicher
				 * angezeigter Name. D.h. ein Wechsel zwischen "Kompressor Liefermenge"
				 * zu "Verbundsteuerung Volumenstrom" ist nicht erlaubt.
				 */
				if (y_value.unit === state.y_value.unit &&
					y_value.i18n_key === state.y_value.i18n_key) {
					new_state.y_value = y_value;
				}
			});
			if (!new_state.y_value) {
				/* Standard: Bei Sprung zur Verbundsteuerung: Liefermenge,
				 * bei Sprung zum Kompressor: Netzdruck
				 */
				new_state.y_value = new_state.y_component_index === -1
					? new_state.y_values[1]
					: new_state.y_values[0];
				new_state.y_range = null;		/* Auto-Y */
			}
			/*
		}
		*/
		return new_state;
	}
	case CHARTS_SET_YVALUE: {
		let new_state = set(state, "y_value", state.y_values[action.index]);
		if (new_state.y_value.unit !== state.y_value.unit) {
			/* Wechsel der Einheit => Auto-Y */
			new_state.y_range = null;
		}
		return new_state;
	}
	case CHARTS_SET_XRANGE: {
		let new_state = set(state, "x_range", action.range);
		if (state.x_mode === X_MODE_MANUAL) {
			/* Wenn wir sowieso schon manuell sind, dann bleibt es jetzt dabei.
			 * In den anderen Fällen muss geprüft werden, ob die Änderung durch
			 * unsere Middleware gekommen ist.
			 */
			return new_state;
		}
		if (action.is_manual_change) {
			/* Die Änderung muss durch Zoom/Move im Diagramm gekommen sein, also
			 * müssen wir jetzt "Manual" anzeigen.
			 */
			new_state = set(new_state, "x_mode", X_MODE_MANUAL);
		}
		return new_state;
	}
	case CHARTS_SET_XMODE:
		/* Die Middleware fummelt nach dieser Action auch nochmal herum,
		 * weil nur dort die Logdaten verfügbar sind (für x_range).
		 */
		if (state.x_mode === action.mode) {
			return state;
		}
		return set(state, "x_mode", action.mode);
	case CHARTS_SET_YRANGE: {
		let new_state = set(state, "y_range", action.range);
		if (state.y_mode === Y_MODE_AUTO) {
			new_state = set(new_state, "y_mode", Y_MODE_MANUAL);
		}
		return new_state;
	}
	case CHARTS_SET_YMODE:
		if (state.y_mode === action.mode) {
			return state;
		}
		return set(state, "y_mode", action.mode);
	case CHARTS_SHOW_COMPRESSOR_STATE: {
		let new_state = set(state, "show_compressor_state", action.value);
		if (action.value) {
			if(state.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
				new_state.state_changes = genStateChanges(state.x_range);
			}
		// else { // state.data_source_index === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
		// } // "else" wird nicht hier behandelt sondern, (wie alles für die he-data-log-files) mit einem redux-saga-watcher,
		//      weil die Daten schon nach dem Herunterladen gesetzt worden sind
		}
		return new_state;
	}
	case CHARTS_SET_DAILY_TIMESPAN: {
		let new_state = set(state, "daily_values.timespan.from_ms", action.from_ms);
		new_state.daily_values.timespan.until_ms = action.until_ms;
		return new_state;
	}
	case CHARTS_SET_DAILY_REQUEST_PENDING:
		return set(state, "daily_values." + action.which + ".request_pending", action.value);
	case CHARTS_SET_DAILY_VALUES: {
		const prop = "daily_values." + action.which + ".data";
		let new_state = set(state, prop, action.data);
		let model = new_state.daily_values[action.which];
		model.request_pending = false;
		model.last_request_ms = action.now_ms;
		model.from_ms = action.from_ms;
		model.until_ms = action.until_ms;
		return new_state;
	}
	case CHARTS_SET_LOG_VALUES: {
		let new_state = set(state, "log_values", action.log_values);
		return new_state;
	}
	case CHARTS_SET_STATE_CHANGES: {
		return {
			...state,
			state_changes: action.stateChanges
		}
	}
	case CHARTS_SET_DATA_SOURCE: {
		return {
			...state,
			data_source_index: action.data_source_index
		}
	}
	default:
		return state;
	}
};

const makeXRange = (log_xrange, minutes) => {
	return [
		log_xrange[1] - minutes * 60 * 1000,
		log_xrange[1]
	];
};

export const findAutoYRange = (log_values, x_range, y_value) => {
	let range = y_value.standard_range;

	log_values.forEach(value => {
		if (value.date < x_range[0] ||
			value.date > x_range[1]) {
			return;
		}
		let y = get(value, y_value.path);
		if (range[0] > y) {
			range[0] = y;
		}
		if (range[1] < y) {
			range[1] = y;
		}
	});
	if (range[0] === Number.POSITIVE_INFINITY ||
		range[1] === Number.NEGATIVE_INFINITY) {
		range = [y_value.y_min, y_value.y_min + y_value.y_step];
	} else if (range[1] - range[0] < y_value.y_step) {
		let half_range = Math.max(range[1] - range[0], y_value.y_step) / 2;
		let median = (range[1] + range[0]) / 2;
		range = [median - half_range, median + half_range];
	}
	range = [range[0], Math.ceil(range[1])];	// wir runden sicherheitshalber aufwärts.
	return range;
};

export const sameDay = (date1, date2) => {
	const d1 = new Date(date1);
	const d2 = new Date(date2);
	return d1.getFullYear() === d2.getFullYear() &&
		d1.getMonth() === d2.getMonth() &&
		d1.getDate() === d2.getDate();
};

/*
War ein Versuch, FireFox u.U. ein bisschen beim Zoomen zu
unterstützen. Hat leider gar nichts gebracht.
const startRebuildLogValues = throttle(dispatch => {
	dispatch(rebuildLogValuesAction());
}, 100, { leading: true, trailing: false });
*/
const startRebuildLogValues = dispatch => dispatch(rebuildLogValuesAction());

export const chartsMiddleware = store => next => action => {
	switch (action.type) {
	case DATALOG_SET_XRANGE: {
		/* Feststellen, ob eine Veränderung des Zeitraums verfügbarer Logdaten
		 * eine Neuberechnung der angezeigten Daten im Diagramm erfordert.
		 */
		const old_log_xrange = store.getState().data_log.xrange;
		const chart_xrange = store.getState().charts.x_range;
		const old_log_x1_within = old_log_xrange[0] >= chart_xrange[0] && old_log_xrange[0] <= chart_xrange[1];
		const old_log_x2_within = old_log_xrange[1] >= chart_xrange[0] && old_log_xrange[1] <= chart_xrange[1];

		/* ACHTUNG: next(action) wird bereits hier ausgeführt, d.h.
		 * data_log.xrange enthält bereits die neuen Werte!
		 */
		const next_result = next(action);

		const new_log_xrange = store.getState().data_log.xrange;
		let rebuild = false;
		const new_log_x1_within = new_log_xrange[0] >= chart_xrange[0] && new_log_xrange[0] <= chart_xrange[1];
		const new_log_x2_within = new_log_xrange[1] >= chart_xrange[0] && new_log_xrange[1] <= chart_xrange[1];
		if ((new_log_xrange[0] !== old_log_xrange[0]) &&
			(new_log_x1_within || old_log_x1_within)) {
			rebuild = true;
		} else if ((new_log_xrange[1] !== old_log_xrange[1]) &&
			(new_log_x2_within || old_log_x2_within)) {
			rebuild = true;
		}
		if (
			rebuild &&
			store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD
		) {
			startRebuildLogValues(store.dispatch);
		}
		if (store.getState().charts.x_mode === X_MODE_X_AUTO &&
			new_log_xrange[1] !== old_log_xrange[1] &&
			store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD
		) {
			store.dispatch(setXRangeAction(
				makeXRange(new_log_xrange, 60), false));
		}
		return next_result;
	}
	case CHARTS_SET_XRANGE: {
		const old_x_range = store.getState().charts.x_range;

		const requested_x_range = action.range;
		let valid_x_range = []
		if(store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
			valid_x_range = store.getState().data_log.xrange;
		}
		else { // store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
			valid_x_range = store.getState().he_data_log_files.xrange;
		}

		const rangediff = requested_x_range[1] - requested_x_range[0];
		if (requested_x_range[1] > valid_x_range[1]) {
			requested_x_range[1] = valid_x_range[1];
			requested_x_range[0] = requested_x_range[1] - rangediff;
		}
		else if (requested_x_range[0] < valid_x_range[0]) {
			requested_x_range[0] = valid_x_range[0];
			requested_x_range[1] = requested_x_range[0] + rangediff;
		}

		/* ACHTUNG: next(action) wird bereits hier ausgeführt, d.h.
		 * charts.x_range enthält bereits die neuen Werte!
		 */
		const next_result = next({
			type: CHARTS_SET_XRANGE,
			range: requested_x_range,
			is_manual_change: action.is_manual_change
		});

		if(store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
			const new_x_range = store.getState().charts.x_range;
			if (old_x_range[0] !== new_x_range[0] ||
				old_x_range[1] !== new_x_range[1]) {
				startRebuildLogValues(store.dispatch);
			}
		}
		// else { // store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
		// } // "else" wird nicht hier behandelt sondern, (wie alles für die he-data-log-files) mit einem redux-saga-watcher,
		//      weil die Daten erst noch heruntergeladen werden müssen
		return next_result;
	}
	case CHARTS_SET_YRANGE: {
		let old_y_range = store.getState().charts.y_range;
		if (old_y_range === null) {
			old_y_range = findAutoYRange(
				store.getState().charts.log_values,
				store.getState().charts.x_range,
				store.getState().charts.y_value)
		}

		/* ACHTUNG: next(action) wird bereits hier ausgeführt, d.h.
		 * charts.x_range enthält bereits die neuen Werte!
		 */
		const next_result = next(action);

		if(store.getState().charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
			const new_y_range = store.getState().charts.y_range;
			if (old_y_range[0] !== new_y_range[0] ||
				old_y_range[1] !== new_y_range[1]) {
				startRebuildLogValues(store.dispatch);
			}
		}
		return next_result;
	}
	case CHARTS_SET_XMODE: {
		const old_x_mode = store.getState().charts.x_mode;

		/* ACHTUNG: next(action) wird bereits hier ausgeführt, d.h. Status-
		 * Änderungen sind dann bereits vollzogen!
		 */
		const next_result = next(action);

		const new_state = store.getState();
		const new_x_mode = new_state.charts.x_mode;
		if (new_x_mode === old_x_mode) {
			return new_state;
		}

		//const log_xrange = new_state.data_log.xrange;
		let log_xrange = []
		if(new_state.charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
			log_xrange = new_state.data_log.xrange;
		}
		else { // new_state.charts.data_source_index === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
			log_xrange = new_state.he_data_log_files.xrange;
		}
		switch (new_x_mode) {
		case X_MODE_X_AUTO:
			/* Diagramme bleibt immer im Bereich "-1h bis "jetzt" */
			store.dispatch(
				setXRangeAction(
					makeXRange(log_xrange, 60), false)
			);
			break;
		case X_MODE_MANUAL:	/* x_range bleibt exakt wie sie ist */
			break;
		case X_MODE_10MIN:
			store.dispatch(
				setXRangeAction(
					makeXRange(log_xrange, 10), false)
			);
			break;
		case X_MODE_30MIN:
			store.dispatch(
				setXRangeAction(
					makeXRange(log_xrange, 30), false)
			);
			break;
		case X_MODE_1H:
			store.dispatch(
				setXRangeAction(
					makeXRange(log_xrange, 60), false)
			);
			break;
		case X_MODE_MAX:
			store.dispatch(
				setXRangeAction(log_xrange, false)
			);
			break;
		default:
			break;
		}
		return next_result;
	}
	case CHARTS_SET_YCOMPONENT:
	case CHARTS_SET_YVALUE:
	case CHARTS_SET_YMODE: {
		const old_y_mode = store.getState().charts.y_mode;

		/* ACHTUNG: next(action) wird bereits hier ausgeführt, d.h. Status-
		 * Änderungen sind dann bereits vollzogen!
		 */
		const next_result = next(action);

		const new_state = store.getState();
		const new_y_mode = new_state.charts.y_mode;
		switch (new_y_mode) {
		case Y_MODE_AUTO:
			if (old_y_mode !== new_y_mode) {
				store.dispatch(setYRangeAction(findAutoYRange(
					new_state.charts.log_values,
					new_state.charts.x_range,
					new_state.charts.y_value
				)));
			}
			break;
		case Y_MODE_MANUAL:
			/* Dieser Wechsel bleibt ohne Folgen */
			break;
		default:
			break;
		}
		return next_result;
	}
	case RTC_ACTION: {
		const old_state = store.getState();
		const timespan = old_state.charts.daily_values.timespan;
		let until_ms = timespan.until_ms;
		if (!until_ms) {
			/* Passiert einmalig beim Start der Anwendung. Abfrage-Intervall auf
			 * den heutigen Tag setzen.
			 */
			until_ms = new Date(old_state.rtc).getTime();
			store.dispatch(setDailyTimespanAction(until_ms, until_ms));
			return next(action);
		} else {
			/* Tageswechsel erkennen, und ggf. folgen */

			let next_result = next(action);

			if (sameDay(old_state.rtc, until_ms)) {
				const new_now_ms = new Date(store.getState().rtc).getTime();
				if (!sameDay(old_state.rtc, new_now_ms)) {
					/* Hier kann man sich noch aussuchen, ob from_ms
					 * mitwandern oder konstant bleiben soll.
					 */
					const diff = timespan.until_ms - timespan.from_ms;
					store.dispatch(setDailyTimespanAction(
						new_now_ms - diff, new_now_ms));
				}
			}
			return next_result;
		}
	}
	default:
		return next(action);
	}
};
